import clsx from "clsx";
import React, { useContext } from "react";
import { WindowContext } from "../WindowResize/resize";

const Modal = ({ children, className, setShowModal }) => {
    const { isMobile } = useContext(WindowContext);

    return (
        <div
            className={clsx(
                "fixed md:absolute bg-white shadow-lg md:min-w-[400px] flex flex-col p-8 z-[200]",
                {
                    "conutry-modal-main left-0": isMobile,
                    "rounded-xl": !isMobile,
                },
                className,
            )}
        >
            <div className="relative text-end -mr-2 md:-mt-4">
                <i
                    className="pi pi-times cursor-pointer text-3xl md:text-2xl self-end text-accent_color1_default"
                    onClick={() => setShowModal(false)}
                ></i>
            </div>
            {children}
        </div>
    );
};

export default Modal;
